module.exports = __webpack_public_path__ + "img/shiba-loading.8356c50b.png";